import {
  displayItemAmountString,
  displayTaxTypeString,
  getFrequencyLabel,
} from "@lib/products";
import { TaxType } from "@lib/shared-types";

import PriceDetails from "./PriceDetails";
import { InvoiceItemType } from "./types";

interface InvoiceDetailsProps {
  // todo
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  invoice: any;
  taxType: TaxType;
  hasPaid?: boolean;
  disableFold?: boolean;
}

const InvoiceDetails: React.FC<InvoiceDetailsProps> = ({
  invoice,
  taxType,
  hasPaid = false,
  disableFold = false,
}) => {
  const getPrettyPrice = (amount: number) =>
    displayItemAmountString(amount / 100, invoice?.currency) as string;

  const stripeInvoice = invoice.invoice;

  const taxTotal = getPrettyPrice(invoice.tax);
  const taxHeader = displayTaxTypeString(taxType);
  const subtotal = getPrettyPrice(invoice.amount);
  const totalHeader = getPrettyPrice(invoice.total);
  const subtotalWithTax = getPrettyPrice(invoice.amount + invoice.tax);
  const couponIsOneTime = stripeInvoice?.discount?.coupon?.duration === "once";
  const totalWithoutCoupon = getPrettyPrice(invoice.amount);
  const appliedBalance =
    stripeInvoice?.starting_balance !== 0
      ? getPrettyPrice(stripeInvoice?.starting_balance)
      : undefined;
  const depositBalance = invoice?.depositBalance
    ? getPrettyPrice(invoice?.depositBalance)
    : undefined;

  const invoiceNumber = stripeInvoice?.number;
  const invoiceDownload = stripeInvoice?.invoice_pdf;
  const invoiceUrl = stripeInvoice?.hosted_invoice_url;
  const paymentRecurring = hasPaid
    ? ""
    : invoice.recurring
      ? `/${getFrequencyLabel(
          invoice.recurring.interval,
          invoice.recurring.intervalCount
        )}`
      : "";
  const headerWithRecurring =
    couponIsOneTime && invoice.recurring && !hasPaid
      ? totalWithoutCoupon + paymentRecurring
      : totalHeader + paymentRecurring;

  const items = invoice.items?.map((item: InvoiceItemType) => {
    return {
      header: `${item.quantity}x ${item.description}`,
      price: getPrettyPrice(item.itemAmount),
    };
  });

  // coupon
  const invCoupon = stripeInvoice?.discount?.coupon;
  const isJPY = invCoupon?.currency === "jpy";
  const isCouponPercent = invCoupon?.percent_off;
  const totalDiscounts = stripeInvoice?.total_discount_amounts?.reduce(
    (total: number, curr: { amount: number }) =>
      total + (isJPY ? curr.amount * 100 : curr.amount),
    0
  );
  const discount = getPrettyPrice(totalDiscounts);

  const coupon = invoice.couponId && {
    unit: isCouponPercent ? "%" : invoice.currency,
    value:
      isCouponPercent || isJPY
        ? invCoupon?.amount_off
        : invCoupon?.amount_off / 100,
  };

  return (
    <PriceDetails
      taxTotal={taxTotal}
      taxHeader={taxHeader}
      subtotal={subtotal}
      subtotalWithTax={subtotalWithTax}
      totalHeader={totalHeader}
      items={items}
      invoiceNumber={invoiceNumber}
      invoiceUrl={invoiceUrl}
      invoiceDownload={invoiceDownload}
      hasPaid={hasPaid}
      coupon={coupon}
      discount={discount}
      disableFold={disableFold}
      headerWithRecurring={headerWithRecurring}
      oneTimeDiscount={couponIsOneTime && invoice.recurring}
      paymentCount={invoice?.recurring?.paymentCount}
      appliedBalance={appliedBalance}
      depositBalance={depositBalance}
    />
  );
};

export default InvoiceDetails;
